import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "GradoPage",
    data() {
        let ss = new MainService();
        return {
            msg: "GradoPage",
            ss: ss,
            ajax: {
                "url": ss.indexGrado(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'Grado', name: 'Grado', title: 'Grado' },
                { data: 'Antiguedad', name: 'Antiguedad', title: 'Antiguedad' },
                { data: 'Fuerza', name: 'Fuerza', title: 'Fuerza' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            grados: [],
            grado: {},
            fuerzas: [],
            fuerza: {},
            
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {

        getFuerza() {
            this.ss.listFuerza().then(
                (result) => {
                    let response = result.data;
                    this.fuerzas = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },

        newGrado() {
            this.grado = {};
            this.$refs['frm-grado'].show();
        },
        showGrado(id) {
            this.isLoading=true;
            this.ss.showGrado(id).then(
                (result) => {
                    let response = result.data;
                    this.grado = response.data;
                    this.$refs['view-grado'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editGrado() {
            this.$refs['frm-grado'].show();
            this.$refs['view-grado'].hide();
        },
        cancelGrado() {
            if (this.grado.id) {
                this.$refs['view-grado'].show();
            }
            this.$refs['frm-grado'].hide();
        },
        saveGrado() {
            this.ss.storeGrado(this.grado).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-grado'].hide();
                    this.$refs['datatable-grado'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteGrado() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyGrado(this.grado)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-grado'].hide();
                                this.$refs['datatable-grado'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-Grado').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showGrado(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
          this.$router.push('/Login');
        } else {
            this.getFuerza();
        }
    }
};
